import React, { useEffect, useState } from "react";
import { Megaphone, Check } from "lucide-react";
import { Label } from "@/components/ui/label";
import api from "@/lib/api";

export function CampaignPicks({ projectId, selectedName, onPick }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!projectId) return;
    api.get(`/projects/${projectId}/goals`).then((r) => setItems((r.data.campaigns || []).filter((c) => c.name))).catch(() => setItems([]));
  }, [projectId]);
  if (!items.length) return null;
  return (
    <div className="rounded-xl border border-primary/20 bg-primary/5 p-3" data-testid="campaign-picks">
      <Label className="mb-2 block text-sm font-bold flex items-center gap-2"><Megaphone className="w-4 h-4 text-primary" /> حملات مقترحة من أهدافك المعتمدة — اختر واحدة أو اكتب اسمك الخاص</Label>
      <div className="flex flex-wrap gap-2">
        {items.map((c, i) => {
          const on = selectedName === c.name;
          return (
            <button key={i} type="button" onClick={() => onPick(c)} data-testid={`campaign-pick-${i}`}
              className={`text-start rounded-xl border px-3 py-2 text-xs transition-colors max-w-full ${on ? "border-primary bg-primary/15 text-primary" : "border-border bg-secondary text-foreground hover:border-primary/50"}`}>
              <span className="font-bold flex items-center gap-1">{on && <Check className="w-3 h-3" />}{c.name}</span>
              {c.serves && <span className="block text-muted-foreground mt-0.5">تخدم: {c.serves}</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
